<div class="itsl-tableview-plan-cell__visibility-toggle">
    {#if config.canEdit}
        <div class="itsl-plan__visibility">
            {#if showHeader}
                <span class="itsl-plan__visibility-toggle-header">{i18n.visibilityHeader}</span>
            {/if}
            <Switch
                id={`visibilityToggle-${guidV4()}`}
                name="itsl-plan__visibility-toggle"
                label={i18n.visibleForStudents}
                checked={plan.isActive}
                on:click={toggleVisibility}
            />
            <Modal
                id={`show-deactivate-elements-modal-id-${guidV4()}`}
                bind:enabled={showDisableElementsConfirmModal}
                titleText={i18n.pleaseConfirm}
                bodyText={i18n.plannerPlanDeactivatedWithElementsWarning}
                confirmText={i18n.yes}
                cancelText={i18n.no}
                on:close={confirmModalClicked}
            />
            <!-- Scheduled visibility will be displayed only if activation is not manual and for inactive Upcoming plans  -->
            {#if isScheduledVisibilityVisible}
                <span class="itsl-plan__visibility-toggle-info">{scheduledVisibility}</span>
            {/if}
        </div>
    {/if}
</div>

<script>
    import Switch from "@itslearning/prometheus/assets/inputs/Switch/v1/Switch.svelte";
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import { createEventDispatcher } from "svelte";
    import { guidV4 } from "@itslearning/atlas/generate/guid.js";
    import { getDateStartString } from "../../helpers/dateHelper.js";
    import { togglePlanElementsActivation } from "../../api.js";

    const timeNow = Date.now();
    const dispatch = createEventDispatcher();

    /**@type {object} config - Configuration object. */
    export let config;
    /**@type {object} plan - The plan entity object. */
    export let plan;
    /**@type {object} i18n - Translation object. */
    export let i18n;
    /**@type {function} setPlanActive - API method to toggle plan activation. */
    export let setPlanActive;
    /**@type {function} getPlan - API method to get plan. */
    export let getPlan;
    /**@type {bool} showHeader - Determines whether header should be shown. Default value is "true". */
    export let showHeader = true;

    let showDisableElementsConfirmModal = false;

    $: activeFromDT =
        plan && plan.activeFromDT && plan.stop && isActiveFromDTValid(plan.activeFromDT, plan.stop)
            ? plan.activeFromDT
            : null;

    $: scheduledVisibility =
        activeFromDT && plan.stop
            ? i18n.scheduledVisibility.replace(
                  "{0}",
                  getDateStartString(activeFromDT, plan.stop, config.locale)
              )
            : "";

    // Return true if activation is not manual and the plan is inactive and Upcoming
    $: isScheduledVisibilityVisible =
        !config.isActivationTypeManually &&
        !plan.isActive &&
        activeFromDT &&
        activeFromDT.getTime() > timeNow;

    // Convert ActiveFromDT in Date and use epoch time to compare time (ms since 1970)
    const isActiveFromDTValid = (activeFrom, to) => activeFrom.valueOf() <= to.valueOf();

    const toggleVisibility = async () => {
        plan.isActive = !plan.isActive;

        // If the planner setting "Activate connected elements when the plan is activated" is enabled and the plan has connected elements,
        // then we need to toggle the element"s visibility according to the plan"s visibility.
        if (config.activateElementsByPlan && plan.elements.length >= 1) {
            // When a plan is activated then all the connected elements are activated
            if (plan.isActive) {
                await setPlanActivation(true, true);
            } else {
                // When a plan is deactivated a confirmation modal appears
                showDisableElementsConfirmModal = true;
            }
        } else {
            await setPlanActivation(false, false);
        }
    };

    // A confirmation modal appears when a plan is deactivated in toggleVisibility
    // "Do you want to deactivate all elements connected to this plan?"
    const confirmModalClicked = ({ detail: { confirmed: toggleElementsActivation } }) =>
        setPlanActivation(toggleElementsActivation, true);

    const setPlanActivation = async (toggleElementsActivation, updateElements) => {
        let elements = null;

        if (!config.newPlan) {
            await setPlanActive(plan.id, plan.isActive, toggleElementsActivation);
        } else if (toggleElementsActivation) {
            await togglePlanElementsActivation(plan.id, plan.isActive);
        }

        if (updateElements) {
            elements = (await getPlan(plan.id)).elements;
        }

        dispatch("planActivationChanged", {
            isActive: plan.isActive,
            elementsUpdated: updateElements,
            elements
        });
    };
</script>
